import { render, staticRenderFns } from "./premiseModal.vue?vue&type=template&id=13018425&"
import script from "./premiseModal.vue?vue&type=script&lang=js&"
export * from "./premiseModal.vue?vue&type=script&lang=js&"
import style0 from "./premiseModal.vue?vue&type=style&index=0&id=13018425&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports